// src/pages/Login/Signup.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const Signup = () => {
  const navigate = useNavigate();
  const { loginUser } = useContext(AuthContext);
  const [name, setName]         = useState('');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState(null);
  const [agreed, setAgreed]     = useState(false);

  // Redirect to login page if user chooses to log in instead
  const handleLogin = () => {
    navigate("/login");
  };

  // Handle form submission for signup
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Optionally, you could add an additional check here:
    // if (!agreed) {
    //   setError("You must agree to the Terms of Use and Privacy Policy.");
    //   return;
    // }
    try {
      const res = await fetch('/api/users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, password })
      });
      const data = await res.json();
      console.log("Signup response data:", data); // Debug: Inspect API response
      if (!res.ok) {
        setError(data.message || 'Signup failed');
      } else {
        const user = data.user;
        const accessToken = data.accessToken;
        const refreshToken = data.refreshToken;

        if (!accessToken) {
          console.error('No access token returned in signup response');
          setError('Signup succeeded, but login failed. Please log in manually.');
          navigate('/login');
          return;
        }

        loginUser(user, accessToken, refreshToken);
        navigate('/');
      }
    } catch (err) {
      setError('Signup failed. Please try again.');
      console.error(err);
    }
  };

  return (
    <section className="login">
      <style>{`header { display: none; }`}</style>
      <div className="container-fluid">
        <div className="row">
          {/* Left side: Logo */}
          <div className="col-xs-12 col-sm-6">
            <div className="login-graphic middle center">
              <img src="/images/Logo.svg" alt="Logo" />
            </div>
          </div>
          {/* Right side: Signup form */}
          <div className="col-xs-12 col-sm-6  first-xs last-sm">
            <div className="login-form middle center">
              <form onSubmit={handleSubmit}>
                <h5 className="text-center">Sign Up</h5>
                {error && <p className="fail">{error}</p>}
                <div className="text-uppercase margin-top-l">Name</div>
                <input 
                  type="text" 
                  name="Name" 
                  value={name} 
                  onChange={(e) => setName(e.target.value)}
                  required 
                />
                <div className="text-uppercase margin-top-l">Email</div>
                <input 
                  type="email" 
                  name="Email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
                <div className="text-uppercase margin-top-l">Password</div>
                <input 
                  type="password" 
                  name="Password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required 
                />
                <div className="checkbox-container margin-top-l">
                  <label>
                    <input 
                      type="checkbox"
                      checked={agreed}
                      onChange={(e) => setAgreed(e.target.checked)}
                      required
                    />{' '}
                    I agree to the <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                  </label>
                </div>
                <div className="form-footer margin-top-l middle">
                  <button
                    type="button"
                    className="text-link"
                    onClick={handleLogin}
                  >
                    or log in here
                  </button>
                  <button type="submit" data-value="question form">Sign up</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Signup;
